import { useState } from 'react';
import React from 'react';
import Checkbox from '@mui/material/Checkbox';

interface IData {
    [key: string]: any;
}

const CheckBoxHeader: React.FC<IData> = (props) =>{
    const [highlight, setHighLight] = useState(true);
    const hanldeClick = () => {
        setHighLight(!highlight);
        props.SetHighLight(!highlight);
    };
    return (
        <div className="custom-group-header">
            <span>{props.displayName}</span>
            <Checkbox size="small" checked={highlight} sx={{ padding:0 }} onClick={hanldeClick}/>
        </div>
    );
};

export default CheckBoxHeader;